import type { LocaleMessages } from './en';

export const fr: LocaleMessages = {
  createYourOwn: {
    SIGN_IN_TO_USE_THIS_TEMPLATE:
      'Connectez-vous ou créez un compte pour personnaliser ce design.',
    CUSTOMIZE_THIS_DESIGN_AS_YOUR_OWN: 'Personnalisez ce design',
    MAKE_YOUR_OWN: 'Personnaliser le Design',
    SIGN_IN_OR_SIGN_UP: "Se connecter ou S'inscrire",
  },
  designLocked: {
    DESIGN_LOCKED_TITLE: 'Ce design est en cours de création',
    DESIGN_LOCKED_TEXT:
      'Ce design est encore en cours de création. Essayez de rafraîchir dans quelques minutes.',
  },
  designPrivate: {
    DESIGN_PRIVATE_TITLE: 'Ce design est privé',
    DESIGN_PRIVATE_TEXT:
      "La personne qui a partagé ce design l'a marqué comme privé. Connectez-vous ou rendez le design public pour le voir.",
  },
  designEmpty: {
    NO_RESULTS_TITLE: 'Ce design est vide',
    NO_RESULTS_MESSAGE:
      "La personne qui a créé ce design n'a encore rien ajouté.",
  },
  design404: {
    TITLE: 'Impossible de trouver le design',
    MESSAGE: "Le design que vous recherchez n'existe pas ou a été supprimé.",
  },
  common: {
    LOADING: 'Chargement...',
    ERROR: 'Erreur',
    SUCCESS: 'Succès',
    SOMETHING_WENT_WRONG: 'Quelque chose a mal tourné',
  },
  actionBar: {
    DOWNLOAD: 'Télécharger PDF',
    SIGN_OUT: 'Se déconnecter',
  },
  companySwitcher: {
    SWITCH_COMPANIES: "Changer d'entreprise",
  },
  viewer: {
    PROMPT_TEXT:
      "Essayez maintenant : Cliquez sur un produit pour voir plus d'informations",
    VIRTUALS_ARE_ILLUSTRATIVE_TEXT:
      'Les maquettes de produits virtuels sont à titre indicatif. La décoration finale peut différer.',
  },
  design: {
    DISCLAIMER:
      'Les prix et la disponibilité des produits peuvent changer. Veuillez confirmer avant de commander.',
  },
  productSidebar: {
    PRODUCT_INFO: 'Informations Produit',
    COLORS: 'Échantillons de Couleurs',
    SIZES: 'Tailles',
    MATERIALS: 'Matériaux',
    PRICING: 'Tarification',
    MOQ: 'Quantité minimale de commande',
    READ_FULL_DESCRIPTION: 'Lire la description complète',
    DOWNLOAD: 'Télécharger',
    NO_IMAGE_AVAILABLE: 'Aucune image disponible',
    VIEW_ON_OUR_WEBSITE: 'Voir sur notre site web',
  },
  pageSetup: {
    CLICK_FOR_PRICING: 'Cliquer pour le prix',
  },
};
